import {
  Copy,
  Flex,
  Heading,
  Square,
  Stack,
  SvgCaretRight,
} from '@grubhubprod/gh-cookbook-react/dist';
import classnames from 'classnames';
import React from 'react';
import {
  useParams,
  useLocation,
  Link as ReactRouterLink,
} from 'react-router-dom';
import { isPhoneView } from 'src/utilities/useScreenSizes';

export interface IMenuItemProps {
  text: string;
  page: string;
  isLast: boolean;
}

export default function NavBarLink({
  text,
  page,
  isLast,
}: IMenuItemProps): JSX.Element {
  const { corpid } = useParams<{ corpid: string }>();
  const { pathname } = useLocation();

  const isTablet = !isPhoneView();

  function routeMatchesModule(): boolean {
    return pathname.indexOf(page) !== -1;
  }

  const isActive = routeMatchesModule();

  return (
    <ReactRouterLink to={`/corporate/management/${corpid}/${page}`}>
      {isTablet ? (
        <Stack
          x={!isLast ? 'lg' : 'sm'}
          style={{
            display: 'flex',
            alignItems: 'center',
          }}
          borderBottomColor={isActive ? 'interactive' : undefined}
          borderBottomStyle={isActive ? 'solid' : undefined}
          borderBottomWidth={isActive ? '3px' : undefined}
        >
          <Square inset="sm" className="navBarLink navBarLink--clickable">
            <Heading variant="h6">{text}</Heading>
          </Square>
        </Stack>
      ) : (
        <Square
          inset="sm"
          className={classnames('navBarLink', {
            navBarLinkMobileActive: routeMatchesModule() && !isTablet,
          })}
        >
          <Flex justifyContent="space-between" alignContent="center">
            <Heading variant="h1">{text}</Heading>
            <Copy variant="body" color="interactive">
              <SvgCaretRight size="24px" />
            </Copy>
          </Flex>
        </Square>
      )}
    </ReactRouterLink>
  );
}
